import { GET_TIMELINES } from 'redux/actions/timelineActions';

const initialState = {
  timelines: {
    loading: false,
    loaded: false,
  },
};

// eslint-disable-next-line import/prefer-default-export
export const timelineReducer = (state = initialState.timelines, action) => {
  switch (action.type) {
    case GET_TIMELINES.pending:
      return {
        ...state,
        loading: true,
      };
    case GET_TIMELINES.success:
      return {
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    case GET_TIMELINES.error:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    default:
      return state;
  }
};
